import { createTheme } from '@mui/material/styles';
import { colors } from './css/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: colors.PRIMARY,
      contrastText: colors.BLACK,
    },
    secondary: {
      main: colors.SECONDARY,
      contrastText: colors.BLACK,
    },
    text: {
      primary: colors.DARKGREY,
      secondary: colors.DUSTYGREY,
    },
    background: {
      default: colors.SECONDARY,
    },
  },
  typography: {
    fontFamily: 'speedee, Arial, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          borderRadius: 4,
        },
      },
    },
  },
});

export default theme;
